var _g, _g2, _g3, _rect, _rect2, _path, _path2, _path3, _path4, _path5, _rect3, _rect4, _path6, _path7, _path8, _path9, _path10, _rect5, _rect6, _path11, _path12, _path13, _path14, _path15, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgItems(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 71 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_201_387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.18185 8.75C7.89676 10.1754 6.82197 11.5176 5.31384 11.8176C4.57831 11.964 3.81531 11.8747 3.13348 11.5623C2.45166 11.25 1.88577 10.7304 1.51639 10.0777C1.14701 9.425 0.99298 8.67239 1.07622 7.92704C1.15946 7.1817 1.47574 6.48161 1.98001 5.92647C3.01431 4.78726 4.76077 4.47366 6.18622 5.04384",
    stroke: "black",
    strokeWidth: 0.912287,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33594 8.17949L4.76139 9.60493L8.18246 5.89877",
    stroke: "black",
    strokeWidth: 0.912287,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_201_387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.18185 25.0543C7.89676 26.4798 6.82197 27.822 5.31384 28.1219C4.57831 28.2684 3.81531 28.179 3.13348 27.8667C2.45166 27.5543 1.88577 27.0347 1.51639 26.382C1.14701 25.7293 0.99298 24.9767 1.07622 24.2314C1.15946 23.486 1.47574 22.7859 1.98001 22.2308C3.01431 21.0916 4.76077 20.778 6.18622 21.3482",
    stroke: "black",
    strokeWidth: 0.912287,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33594 24.4839L4.76139 25.9094L8.18246 22.2032",
    stroke: "black",
    strokeWidth: 0.912287,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_201_387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.18185 42.3169C7.89676 43.7424 6.82197 45.0846 5.31384 45.3845C4.57831 45.531 3.81531 45.4417 3.13348 45.1293C2.45166 44.8169 1.88577 44.2973 1.51639 43.6446C1.14701 42.9919 0.99298 42.2393 1.07622 41.494C1.15946 40.7486 1.47574 40.0485 1.98001 39.4934C3.01431 38.3542 4.76077 38.0406 6.18622 38.6108",
    stroke: "black",
    strokeWidth: 0.912287,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33594 41.7467L4.76139 43.1721L8.18246 39.4659",
    stroke: "black",
    strokeWidth: 0.912287,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.7207,
    y: 0.389526,
    width: 55.4696,
    height: 14.959,
    rx: 0.655731,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.7207,
    y: 0.389526,
    width: 55.4696,
    height: 14.959,
    rx: 0.655731,
    stroke: "black",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0295 1.95099H19.3628C18.6619 1.95099 18.0938 2.52002 18.0938 3.22196V12.5161C18.0938 13.218 18.6619 13.787 19.3628 13.787H32.0295C32.7304 13.787 33.2985 13.218 33.2985 12.5161V3.22196C33.2985 2.52002 32.7304 1.95099 32.0295 1.95099Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5211 12.0171H30.0166C30.312 12.0171 30.4956 11.6952 30.3459 11.4403L26.5868 5.04001C26.4301 4.77313 26.0378 4.79362 25.9096 5.075L24.0946 9.05833C23.9868 9.29473 23.6799 9.3572 23.4888 9.18178L22.7548 8.50756C22.5841 8.35113 22.3146 8.38111 22.1829 8.57103L20.2077 11.4158C20.0316 11.6697 20.2127 12.0171 20.5216 12.0171H20.5211Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4095 6.10903C31.1059 5.82013 31.4366 5.02052 31.1482 4.32306C30.8597 3.62559 30.0613 3.29438 29.3649 3.58328C28.6686 3.87218 28.3378 4.67179 28.6263 5.36926C28.9148 6.06673 29.7131 6.39793 30.4095 6.10903Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8869 7.1088H35.7493C35.2358 7.1088 34.8188 6.69123 34.8188 6.1769C34.8188 5.66256 35.2358 5.245 35.7493 5.245H65.8869C66.4004 5.245 66.8174 5.66256 66.8174 6.1769C66.8174 6.69123 66.4004 7.1088 65.8869 7.1088Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8869 10.493H35.7493C35.2358 10.493 34.8188 10.0754 34.8188 9.56105C34.8188 9.04672 35.2358 8.62915 35.7493 8.62915H65.8869C66.4004 8.62915 66.8174 9.04672 66.8174 9.56105C66.8174 10.0754 66.4004 10.493 65.8869 10.493Z",
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.7207,
    y: 17.6602,
    width: 55.4696,
    height: 14.959,
    rx: 0.655731,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14.7207,
    y: 17.6602,
    width: 55.4696,
    height: 14.959,
    rx: 0.655731,
    stroke: "black",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0295 19.2216H19.3628C18.6619 19.2216 18.0938 19.7906 18.0938 20.4926V29.7867C18.0938 30.4886 18.6619 31.0577 19.3628 31.0577H32.0295C32.7304 31.0577 33.2985 30.4886 33.2985 29.7867V20.4926C33.2985 19.7906 32.7304 19.2216 32.0295 19.2216Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5211 29.2875H30.0166C30.312 29.2875 30.4956 28.9656 30.3459 28.7107L26.5868 22.3104C26.4301 22.0435 26.0378 22.064 25.9096 22.3454L24.0946 26.3287C23.9868 26.5651 23.6799 26.6276 23.4888 26.4522L22.7548 25.7779C22.5841 25.6215 22.3146 25.6515 22.1829 25.8414L20.2077 28.6862C20.0316 28.9401 20.2127 29.2875 20.5216 29.2875H20.5211Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4091 23.3792C31.1055 23.0903 31.4362 22.2907 31.1477 21.5932C30.8592 20.8957 30.0609 20.5645 29.3645 20.8534C28.6681 21.1423 28.3374 21.9419 28.6258 22.6394C28.9143 23.3369 29.7127 23.6681 30.4091 23.3792Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8869 24.3794H35.7493C35.2358 24.3794 34.8188 23.9618 34.8188 23.4475C34.8188 22.9331 35.2358 22.5156 35.7493 22.5156H65.8869C66.4004 22.5156 66.8174 22.9331 66.8174 23.4475C66.8174 23.9618 66.4004 24.3794 65.8869 24.3794Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8869 27.7636H35.7493C35.2358 27.7636 34.8188 27.3461 34.8188 26.8317C34.8188 26.3174 35.2358 25.8998 35.7493 25.8998H65.8869C66.4004 25.8998 66.8174 26.3174 66.8174 26.8317C66.8174 27.3461 66.4004 27.7636 65.8869 27.7636Z",
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 14.7207,
    y: 34.9308,
    width: 55.4696,
    height: 14.959,
    rx: 0.655731,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 14.7207,
    y: 34.9308,
    width: 55.4696,
    height: 14.959,
    rx: 0.655731,
    stroke: "black",
    strokeWidth: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0295 36.4922H19.3628C18.6619 36.4922 18.0938 37.0613 18.0938 37.7632V47.0573C18.0938 47.7593 18.6619 48.3283 19.3628 48.3283H32.0295C32.7304 48.3283 33.2985 47.7593 33.2985 47.0573V37.7632C33.2985 37.0613 32.7304 36.4922 32.0295 36.4922Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5211 46.5583H30.0166C30.312 46.5583 30.4956 46.2364 30.3459 45.9815L26.5868 39.5812C26.4301 39.3143 26.0378 39.3348 25.9096 39.6162L24.0946 43.5995C23.9868 43.8359 23.6799 43.8984 23.4888 43.723L22.7548 43.0488C22.5841 42.8923 22.3146 42.9223 22.1829 43.1122L20.2077 45.957C20.0316 46.2109 20.2127 46.5583 20.5216 46.5583H20.5211Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4091 40.6501C31.1055 40.3612 31.4362 39.5616 31.1477 38.8641C30.8592 38.1667 30.0609 37.8355 29.3645 38.1244C28.6681 38.4133 28.3374 39.2129 28.6258 39.9103C28.9143 40.6078 29.7127 40.939 30.4091 40.6501Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8869 41.65H35.7493C35.2358 41.65 34.8188 41.2324 34.8188 40.7181C34.8188 40.2038 35.2358 39.7862 35.7493 39.7862H65.8869C66.4004 39.7862 66.8174 40.2038 66.8174 40.7181C66.8174 41.2324 66.4004 41.65 65.8869 41.65Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8869 45.0345H35.7493C35.2358 45.0345 34.8188 44.617 34.8188 44.1026C34.8188 43.5883 35.2358 43.1707 35.7493 43.1707H65.8869C66.4004 43.1707 66.8174 43.5883 66.8174 44.1026C66.8174 44.617 66.4004 45.0345 65.8869 45.0345Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_201_387"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.12287,
    height: 9.12285,
    fill: "white",
    transform: "translate(0.0600586 3.76111)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_201_387"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.12287,
    height: 9.12285,
    fill: "white",
    transform: "translate(0.0600586 20.0657)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_201_387"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.12287,
    height: 9.12285,
    fill: "white",
    transform: "translate(0.0600586 37.328)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItems);
export default __webpack_public_path__ + "static/media/items.7d58c964f6bf906dec5d736afb12b228.svg";
export { ForwardRef as ReactComponent };